import { Flex } from 'antd'
import type { PropsWithChildren } from 'react'

import { useStyles } from './styles'

export const Container = ({ children }: PropsWithChildren) => {
  const { styles } = useStyles()

  return <Flex className={styles.container}>{children}</Flex>
}
